import styled from 'styled-components';
import * as Dialog from '@radix-ui/react-dialog';
import { BodyTextRegularC, HeadingMediumH5 } from '@/shared/ui/typography2';

export const DialogOverlay = styled(Dialog.Overlay)`
  position: fixed;
  inset: 0;
  animation: overlayShow 150ms cubic-bezier(0.16, 1, 0.3, 1);
`;
export const DialogContent = styled(Dialog.Content)`
  display: flex;
  width: 300px;

  padding: 24px 18px 18px 18px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 24px;

  border-radius: 12px;
  background-color: rgba(19, 19, 21, 0.75);
  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
  backdrop-filter: blur(24px);
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  animation: contentShow 150ms cubic-bezier(0.16, 1, 0.3, 1);
  @media (orientation: landscape) {
    height: 183px;
  }
  @media (orientation: portrait) {
    width: 254px;
  }
`;
export const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 8px;
`;

export const DialogTitle = styled(Dialog.Title)`
  ${HeadingMediumH5};
`;
export const DialogDescription = styled(Dialog.Description)`
  ${BodyTextRegularC};
  color: #afafaf;
  text-align: center;
`;
export const Buttons = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  align-self: stretch;
  width: 100%;
  @media (orientation: portrait) {
    flex-direction: column;
  }
`;
const DialogButton = styled.button`
  display: flex;
  height: 48px;
  min-width: 120px;
  justify-content: center;
  align-items: center;
  flex: 1 0 0;
  border-radius: 8px;
  @media (orientation: portrait) {
    flex: none;
    width: 100%;
  }
`;
export const ExitButton = styled(DialogButton)`
  //padding: 0 24px;
  gap: 12px;
  background: rgba(208, 51, 49, 0.5);
`;
export const CancelButton = styled(DialogButton)`
  //padding: 0 16px;
  gap: 8px;
  background: #625a63;
`;
